import { Injectable } from '@angular/core';
import { ServiceBase } from './service-base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IntentService extends ServiceBase {
  
  protected override get serviceDomain(): string {
    return 'intent';
  }

  // New method to get intent groups
  getIntentGroups(): Observable<{ key: number, value: string }[]> {
    return this.httpClient.get<{ key: number, value: string }[]>(`${this.baseUrl}/Groups`);
  }

}
